import { getStaffList } from 'services/axios/staff'

export const actions = {
  GET_STAFF_LIST: 'GET_STAFF_LIST',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
  HANDLE_EMPLOYEE_SEARCH: 'HANDLE_EMPLOYEE_SEARCH',
}

export const getStaffMembers = ({ skip, limit, searchedEmp }) => {
  return async (dispatch) => {
    const response = await getStaffList({ skip, limit, searchedEmp })

    dispatch({
      type: actions.GET_STAFF_LIST,
      payload: {
        membersList: response?.data?.data?.employee,
        totalCount: response?.data?.data?.totalCount,
        allMembersList: response?.data?.data?.allEmployee,
      },
    })
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}
export const handleEmpSearch = (searchedEmp) => {
  return {
    type: 'HANDLE_EMPLOYEE_SEARCH',
    payload: searchedEmp,
  }
}
